import { memberApi } from './api';

const SW_PATH = '/sw.js';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export async function ensurePushServiceWorker() {
  if (!pushSupported()) return null;
  const existing = await navigator.serviceWorker.getRegistration(SW_PATH);
  if (existing) return existing;
  return navigator.serviceWorker.register(SW_PATH, { scope: '/' });
}

export async function getPushPermission() {
  if (!pushSupported()) return 'unsupported';
  return Notification.permission;
}

export async function enablePushNotifications() {
  if (!pushSupported()) {
    throw new Error('Push notifications are not supported in this browser.');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission was not granted.');
  }

  const meta = await memberApi.pushVapidKey();
  if (!meta?.configured || !meta.publicKey) {
    throw new Error('Push notifications are not configured on the server yet.');
  }

  const registration = await ensurePushServiceWorker();
  await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(meta.publicKey),
    });
  }

  const json = subscription.toJSON();
  await memberApi.pushSubscribe({
    endpoint: json.endpoint,
    keys: json.keys,
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
  });
  return { ok: true, permission };
}

export async function disablePushNotifications() {
  if (!pushSupported()) return { ok: true };
  const registration = await navigator.serviceWorker.getRegistration(SW_PATH);
  const subscription = registration ? await registration.pushManager.getSubscription() : null;
  if (subscription) {
    try {
      await memberApi.pushUnsubscribe({ endpoint: subscription.endpoint });
    } catch {
      /* still unsubscribe locally */
    }
    await subscription.unsubscribe();
  }
  return { ok: true };
}

export function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
